import { render, staticRenderFns } from "./SundrySupplierDocumentList.vue?vue&type=template&id=cd98beb6&scoped=true&"
import script from "./SundrySupplierDocumentList.vue?vue&type=script&lang=js&"
export * from "./SundrySupplierDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./SundrySupplierDocumentList.vue?vue&type=style&index=0&id=cd98beb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd98beb6",
  null
  
)

export default component.exports